import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { usePreferencesStore } from '@/store/preferences';
import { useLayoutField } from '@/composables/useLayoutField';
import { useHydratedHeaders } from '@/composables/useHydratedHeaders';
import Toolbar from '@/components/layout/Toolbar.vue';
import Pagination from '@/components/layout/Pagination.vue';
import { configRegistry } from '@/lib/configRegistry';


const __default__ = {};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ViewsContainer',
  props: {
    moduleName: {},
    listViewComponent: {},
    calendarViewComponent: {},
    gridViewComponent: {},
    cardViewComponent: {},
    filterComponent: {},
    data: {},
    config: {},
    onCreate: { type: Function },
    onUpdate: { type: Function },
    onRecordUpdate: { type: Function },
    onDelete: { type: Function },
    show_toolbar: { type: Boolean },
    show_pagination: { type: Boolean },
    title: {}
  },
  setup(__props: any) {

const props = __props;

const preferencesStore = usePreferencesStore();
const route = useRoute();
const router = useRouter();
const statusField = ref<string>('');


const currentViewComponent = computed(() => {
  switch (useLayoutField(props.moduleName, 'currentView').value) {
    case 'table':
      return props.listViewComponent;
    case 'grid':
      return props.gridViewComponent;
    case 'card':
      return props.cardViewComponent;
      case 'calendar':
      return props.calendarViewComponent;
    default:
      return props.listViewComponent;
  }
});

const availableViews = computed(() => {
  const views = [];
  if (props.listViewComponent) views.push('table');
  if (props.gridViewComponent) views.push('grid');
  if (props.cardViewComponent) views.push('card');
  if (props.calendarViewComponent) views.push('calendar');
  return views;
});

const headers = useHydratedHeaders();
const sortableHeaders = computed(() =>
  preferencesStore.allModuleHeaders.filter((h) => h.sortable)
);

const showDialog = ref(false);
const selectedId = ref<number | null>(null);
const detailComponent = ref<any>(null);

// 🚀 Carga el componente DETAIL dinámicamente si no existe
const loadDetailComponent = async () => {
  const loader = configRegistry[props.moduleName];
  if (!loader) {
    console.warn(`No se encontró config para módulo: ${props.moduleName}`);
    return;
  }
  const mod = await loader();
  if (mod?.DETAIL?.component) {
    detailComponent.value = await mod.DETAIL.component;
  } else {
    console.warn(`[${props.moduleName}] No se definió DETAIL.component`);
  }
};

// 👀 Verifica si hay un `id` en la URL (por acceso directo o navegación interna)
const syncDialogWithRoute = async () => {
  const id = route.params.id;
  if (id) {
    selectedId.value = +id;
    await loadDetailComponent();
    showDialog.value = true;
  }
};

// 🧠 Observa cambios de ID en la URL y sincroniza el diálogo
watch(
  () => route.params.id,
  async (newId, oldId) => {
    if (newId && newId !== oldId) {
      await syncDialogWithRoute();
    }
    if (!newId && showDialog.value) {
      showDialog.value = false;
      selectedId.value = null;
    }
  },
  { immediate: true }
);

// 🟢 Abrir el diálogo desde acción del usuario
const openDetailDialog = async (item: any) => {
  selectedId.value = item?.id ?? item;
  await loadDetailComponent();
  showDialog.value = true;

  router.push({
    name: route.name as string,
    params: { ...route.params, id: selectedId.value },
    query: route.query,
  });
};

// 🔴 Cerrar el diálogo y limpiar el param `id` de la URL
const closeDialog = () => {
  showDialog.value = false;
  selectedId.value = null;

  const { id, ...otherParams } = route.params;

  router.replace({
    name: route.name as string,
    params: { ...otherParams },
    query: route.query,
  });
};

onMounted(async () => {
    const loader = configRegistry[props.moduleName];
    if (loader) {
      const mod = await loader();
      statusField.value = mod?.KANBAN?.statusField ?? 'status'; // fallback genérico
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.show_toolbar)
      ? (_openBlock(), _createBlock(Toolbar, {
          key: 0,
          moduleName: _ctx.moduleName,
          sortableHeaders: sortableHeaders.value,
          config: _ctx.config,
          onCreate: _ctx.onCreate,
          title: _ctx.title,
          availableViews: availableViews.value
        }, null, 8, ["moduleName", "sortableHeaders", "config", "onCreate", "title", "availableViews"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(currentViewComponent.value), {
      moduleName: _ctx.moduleName,
      headers: _unref(headers),
      data: _ctx.data,
      config: _ctx.config,
      onUpdate: _ctx.onUpdate,
      onRecordUpdate: _ctx.onRecordUpdate,
      onDelete: _ctx.onDelete,
      onViewItem: openDetailDialog,
      onEditItem: _ctx.openEditDialog,
      title: _ctx.title,
      statusField: statusField.value
    }, null, 40, ["moduleName", "headers", "data", "config", "onUpdate", "onRecordUpdate", "onDelete", "onEditItem", "title", "statusField"])),
    _createVNode(_component_v_dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event)),
      fullscreen: "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        (detailComponent.value && selectedId.value)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(detailComponent.value), {
              key: 0,
              id: selectedId.value,
              onClose: closeDialog,
              onUpdate: _ctx.onUpdate
            }, null, 40, ["id", "onUpdate"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.show_pagination)
      ? (_openBlock(), _createBlock(Pagination, {
          key: 1,
          moduleName: _ctx.moduleName,
          title: _ctx.title
        }, null, 8, ["moduleName", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})